// The pages below `/settings/blocked` (Sharing & blocked users): the index, the granted access by calendar or by user, and the blocked users.
export type SharingView =
  | { view: 'index' | 'granted' | 'calendars' | 'users' | 'blocked' | 'blockedAdd' }
  | { view: 'calendar'; calendarId: number }
  | { view: 'user'; key: string }
  | { view: 'unknown' }

const NUMBER = /^\d+$/

// `rest` is the route's `:rest*` parameter (what follows `/settings/blocked/`): `[]`, `['granted']`, `['granted', 'calendars']`,
// `['granted', 'calendars', '8']`, `['granted', 'users']`, `['granted', 'users', 'user:5']`, `['users']` or `['users', 'add']`.
export function parseSharingPath(rest: string | string[] | undefined): SharingView {
  const parts = (Array.isArray(rest) ? rest : [rest ?? '']).filter((part) => part !== '')
  if (!parts.length) return { view: 'index' }
  if (parts[0] === 'users') {
    if (parts.length === 1) return { view: 'blocked' }
    return parts.length === 2 && parts[1] === 'add' ? { view: 'blockedAdd' } : { view: 'unknown' }
  }
  if (parts[0] !== 'granted') return { view: 'unknown' }
  if (parts.length === 1) return { view: 'granted' }
  if (parts[1] === 'calendars') {
    if (parts.length === 2) return { view: 'calendars' }
    return parts.length === 3 && NUMBER.test(parts[2]) ? { view: 'calendar', calendarId: Number(parts[2]) } : { view: 'unknown' }
  }
  if (parts[1] === 'users') {
    if (parts.length === 2) return { view: 'users' }
    return parts.length === 3 ? { view: 'user', key: parts[2] } : { view: 'unknown' }
  }
  return { view: 'unknown' }
}

export const SHARING_ROOT = '/settings/blocked'

// A path below the category; the parts are encoded (a grantee key holds a colon).
export function sharingPath(...parts: (string | number)[]): string {
  return [SHARING_ROOT, ...parts.map((part) => encodeURIComponent(String(part)))].join('/')
}

// Where Back goes from a page: one level up, the index goes to `/settings`.
export function sharingParent(view: SharingView): string {
  switch (view.view) {
    case 'index':
      return '/settings'
    case 'granted':
    case 'blocked':
    case 'unknown':
      return sharingPath()
    case 'calendars':
    case 'users':
      return sharingPath('granted')
    case 'calendar':
      return sharingPath('granted', 'calendars')
    case 'user':
      return sharingPath('granted', 'users')
    case 'blockedAdd':
      return sharingPath('users')
  }
}
